// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5JHZq","item":"styles_item__qSIbf","label":"styles_label__5VM5a"};